import { Form, InputNumber } from "antd";
import './index.less';
import { useTranslation } from "react-i18next";
import { getNativeTokenInfo } from "@/request/native";
const nativeTokenInfo = getNativeTokenInfo();

function InputNumberAddon({ symbol, ...restProps }: any) {
  return (
    <div className="input-number-addon-box">
      <InputNumber className="mini-input-number" {...restProps} controls={false} />
      <div className="addon">
        {symbol}
      </div>
    </div>
  );
}

export default function AllAmount({ form, symbol }: any) {
  const { t } = useTranslation()
  return (
    <div className="fixed-amount-box">
      <h3>{ t("manyToMany.sendAmountPerAddress") }</h3>
      <Form.Item
        name="allAmount"
        label={null}
      >
        <InputNumberAddon symbol={symbol || nativeTokenInfo.symbol}  precision={4}  placeholder={ t("manyToMany.allBalance") } disabled/>
      </Form.Item>
    </div>
  );
}
